import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    border-left: transparent;
  }
  .ant-tabs-ink-bar {
    left: 0;
  }
  :where(.css-dev-only-do-not-override-yp8pcc).ant-tabs-left
    > .ant-tabs-nav
    .ant-tabs-nav-wrap {
    border-right: solid;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.colors.blue.primary} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    text-shadow: 0;
  }

  && .ant-tabs-nav {
    border-bottom: none !important;

    &:before {
      border: none;
    }
  }
`;
